import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { GalleryAccessLevelService } from '../../services/gallery-access-level.service';
import { ViewGalleryResolve } from './view-gallery.resolve';

@Injectable({
  providedIn: 'root',
})
export class ViewGalleryAccessLevelResolve {
  private viewGalleryResolve = inject(ViewGalleryResolve);
  private accessLevelService = inject(GalleryAccessLevelService);
  private platformId = inject<string>(PLATFORM_ID);

  async resolve(next: ActivatedRouteSnapshot) {
    const gallery = await this.viewGalleryResolve.resolve(next);
    if (!gallery) return;
    if (isPlatformServer(this.platformId)) return gallery.public_access;
    return this.accessLevelService.getAccessLevel(gallery);
  }
}
